import { useQuery } from '@tanstack/react-query'
import { getSoldTicketsInfo } from 'api/ticket'
import { SoldTicketInfo } from 'types/Ticket'

export const useSoldTicketsInfo = (eventId: string, enabled: boolean = true) => {
    return useQuery<Record<string, SoldTicketInfo>>({
        queryKey: ['soldTicketsInfo', eventId],
        queryFn: () => getSoldTicketsInfo(eventId),
        enabled,
        staleTime: 30000, // 30 seconds
        refetchInterval: 60000, // Refetch every minute
    })
}
